import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { t } from 'i18next';
import api from '../API/apiCollection';
import { orderCartDetailsReset } from '../redux/orderCartDetails';
import { resetState } from '../redux/cart';
import { cartDetails } from '../redux/orderCartDetails';
import toast from 'react-hot-toast';
import { Button } from '@mui/material';
import { set } from 'date-fns';
import { deliveryAddressReset } from '../redux/DeliveryAddress';
import { resetStatePromo } from '../redux/Promocode';

const Fygaro = ({
    amount,
    isCustomJobRequest,
    customJobReqData,
}) => {

    
    const settings = useSelector((state) => state.Settings)?.settings;
    const paymentsettings = settings?.payment_gateways_settings;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const orderDetails = useSelector(
        (state) => state.OrderCartDetails
    )?.orderDetails;

    const delivery_type = useSelector(
        (state) => state.DeliveryAddress
    )?.deliveryType;
    const deliveryAddress = useSelector(
        (state) => state.DeliveryAddress
    )?.delivery;

    const orderNotes = orderDetails.orderNote;

    let promocode = useSelector((state) => state.Promocode);
    const coupanCodes = promocode.promocode;
    let selectedPromoCode = promocode.selectedPromoCode;

    const handleFygaroPayment = async () => {
        try {
            // Place order first
            const orderResponse = await api.placeOrder({
                method: "fygaro",
                date: orderDetails?.date,
                time: orderDetails?.slot,
                addressId: delivery_type === "Home" ? deliveryAddress?.id : "",
                order_note: orderNotes,
                promo_code_id: selectedPromoCode?.id,
                custom_job_request_id: isCustomJobRequest ? customJobReqData?.custom_job_request_id : "",
                bidder_id: isCustomJobRequest ? customJobReqData?.partner_id : "",
            });
            const fygaroLink = orderResponse.data.fygaro;
            if (fygaroLink) {

                // Redirect to Fygaro payment page
                window.location.href = fygaroLink;
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
            dispatch(resetState());
            dispatch(orderCartDetailsReset());
            dispatch(deliveryAddressReset());
            dispatch(resetStatePromo());
        } catch (error) {
            console.error('Fygaro payment error:', error);
            toast.error(t('payment_failed'));
        }
    };

    return (
        <Button
            variant="outlined"
            fullWidth
            sx={{ my: 1 }}
            onClick={handleFygaroPayment}
        >
            {t("make_a_payment")} {t("with")} {t("fygaro")}
        </Button>
    );
};

export default Fygaro; 